import { render, staticRenderFns } from "./todayCourseLive.vue?vue&type=template&id=46054d93&scoped=true"
import script from "./todayCourseLive.vue?vue&type=script&lang=js"
export * from "./todayCourseLive.vue?vue&type=script&lang=js"
import style0 from "./todayCourseLive.vue?vue&type=style&index=0&id=46054d93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46054d93",
  null
  
)

export default component.exports